import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "bodyInput", "bodyInputWrapper", "noteButton", "expandNotes", "collapsedNotes"]

  addSimpleNote(event) {
    this.bodyInputTarget.value = event.params.body
    this.submitForm()
  }

  toggleBodyInput() {
    this.bodyInputWrapperTarget.classList.remove("d-none")
  }

  submitForm() {
    event.preventDefault()
    this.formTarget.requestSubmit()
    this.resetForm()
  }

  resetForm() {
    this.bodyInputTarget.value = ""
    if (this.hasBodyInputWrapperTarget) this.bodyInputWrapperTarget.classList.add("d-none")
  }

  expandNotes() {
    this.expandNotesTarget.classList.add("d-none")
    this.collapsedNotesTarget.classList.remove("d-none")
  }
}
